import React, { Component } from 'react';
import {Card, CardTitle, CardText} from 'material-ui/Card';

class Page extends Component {

  render() {
    return (
      <Card>
        <CardTitle title="Moving forward..." subtitle="5/5" />
        <CardText>
          <p>Make sure that the guidelines are followed during the project and any change is reported.</p>
          <p>Moreover, it is desirable to conduct a critical analysis on the use of the selected guidelines and supporting literature. Such reflection could be included in the study report, thus informing fellow researchers the lessons learned during the process.</p>
        </CardText>
        <CardTitle title="How to report the this?" subtitle="" />
        <CardText>
          <p>In our article<sup>[2]</sup>, we propose a table format for aggregating the selected references. Please </p>
          <p>[2] Molléri J S, Petersen Kai and Mendes E. CERSE - Catalog for Empirical Research in Software Engineering - A Systematic Mapping Study.Information and Software Technology [under review] 2017.</p>
        </CardText>
      </Card>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/Step5.js